// extracted by mini-css-extract-plugin
export default {"caption":"TxStateModals_caption__LUPN8","link":"TxStateModals_link__vE4eR"};